import React from "react";
import whynad from "../Assets/whynad.png";
import { motion } from "framer-motion";

const WhyNad = () => {
  return (
    <section id="why-nad" className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white flex flex-col items-center text-center">
      <motion.div
        className="flex flex-col items-center text-center"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <motion.img
          src={whynad}
          alt="Why Nad"
          className="w-90 h-auto mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        />

        <motion.h2
          className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          WHY Nads Trading Bot
        </motion.h2>

        <motion.h4
          className="text-base sm:text-lg md:text-xl lg:text-3xl text-gray-300 mb-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          Trade your way with full control inside Telegram.
        </motion.h4>

        <motion.p
          className="text-sm sm:text-base md:text-lg text-gray-200 max-w-3xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          Minimum Position Value, hide tiny tokens. <br/> Auto Buy, paste token, buy instantly. <br/> Slippage Config, protect trades in volatility. <br/> Transaction Priority, boost speed when seconds matter. <br/> Sell Protection, confirm before full sells.
        </motion.p>
      </motion.div>
    </section>
  );
};

export default WhyNad;
